|<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">

      <h1 class="headline mb-1">Formulario para solicitar firma</h1>

      <v-stepper v-model="paso">
        <v-stepper-header>

          <v-stepper-step :complete="paso > 1" step="1">Solicitudes</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="paso > 2" step="2">Formulario</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="paso > 3" step="3">Contraseña</v-stepper-step>
          
          <v-divider></v-divider>

          <v-stepper-step :complete="paso > 4" step="4">Carga de documentos</v-stepper-step>
          
          <v-divider></v-divider>

          <v-stepper-step step="5">Validación de identidad</v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          
          <v-stepper-content step="1">

            <div class ="container">
              
              <v-data-table :headers="headers_table" :items="listado_solicitudes">

                <template v-slot:top>

                  <v-toolbar
                    flat
                  >

                  <v-toolbar-title>Listado de solicitudes</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>

                  <template>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="nuevaSolicitud()"
                    >
                    <v-icon depressed>add</v-icon>
                      Nueva solicitud
                    </v-btn>
                  </template>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>

                  <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="actualizarTabla()"
                    >
                    <v-icon>fas fa-circle-notch fa-spin</v-icon>
                    <v-icon depressed>update</v-icon>
                      Actualizar
                    </v-btn>

                    <v-dialog
                      v-model="modal_update"
                      hide-overlay
                      persistent
                      width="300"
                    >
                      <v-card
                        color="primary"
                        dark
                      >
                        <v-card-text>
                          Actualizando solicitudes
                          <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                          ></v-progress-linear>
                        </v-card-text>
                      </v-card>
                    </v-dialog>

                  

                  <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                  <tr>
                    <td class="text-xs-right">{{ item.created_at | moment }}</td>
                  </tr>
                </template>

                <template v-slot:[`item.updated_at`]="{ item }">
                  <tr>
                    <td class="text-xs-right">{{ item.updated_at | moment }}</td>
                  </tr>
                </template>

                <template v-slot:[`item.accion`]="{ item }">
                  <v-icon v-if ="item.estado === 'Pendiente'">check_circle</v-icon>
                  <v-icon  @click="editItem(item)" v-if ="item.estado === 'Rechazada'">check</v-icon>
                  <v-icon  @click="editItem(item)" v-if ="item.estado === 'Aprobada'">fas fa-lock</v-icon>

                  <span class="group pa-2">
                      <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                      v-if ="item.estado === 'Nueva Solicitud'"
                    >
                      mdi-pencil
                    </v-icon>
                    
                     <v-icon  @click="iniciarVerificacion(item)" v-if ="item.estado === 'Verificacion Virtual'">fact_check</v-icon>

                     <v-icon  @click="editItem(item)" v-if ="item.estado === 'Revision'">lock_clock</v-icon>

                     <v-icon  v-if ="item.estado === 'Solicitud'">task_alt</v-icon>
                     
                  </span>

                </template>
              </v-data-table>
            </div>
        
          </v-stepper-content>

          <v-stepper-content step="2">
              <v-form
                ref="formFirma" 
                v-model="validForm" 
                lazy-validation>
                <v-card-text>
                  <v-autocomplete
                    outlined
                    v-model="t_certi_object"
                    :items="certificado_tipo"
                    item-text= "descripcion"
                    item-value = item
                    :filter="customFilter"
                    class="mt-0 pt-0"
                    @change="changeFields"
                    :rules="[rules.required]"
                    label="Tipo de certificado"
                    return-object
                  ></v-autocomplete>
               
                  <v-row v-if="t_certificado == '10001'">
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.razon_social"  
                        class="mt-0 pt-0"
                        :rules="[rules.required]"
                        label="Razón social">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.nombre_comercial"  
                        class="mt-0 pt-0"
                        :rules="[rules.required]"
                        label="Nombre comercial">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.primer_nombre"  
                        class="mt-0 pt-0"
                        :rules="[rules.required]"
                        label="Primer nombre">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.segundo_nombre"  
                        class="mt-0 pt-0"
                        label="Segundo nombre">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.otros_nombres"  
                        class="mt-0 pt-0"
                        label="Otros nombres">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.primer_apellido"  
                        class="mt-0 pt-0"
                        :rules="[rules.required]"
                        label="Primer apellido">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.segundo_apellido"  
                        class="mt-0 pt-0"
                        label="Segundo apellido">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.casada_apellido"  
                        class="mt-0 pt-0"
                        label="Apellido casada">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-menu ref="menu" v-model="menu" 
                        :close-on-content-click="false"
                        :return-value.sync="fecha_nacimiento"
                        transition="scale-transition"
                        offset-y  min-width="auto"  >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            locale="es"
                            v-model="prisma_solicitud_certificado.fecha_nacimiento"
                            label="Fecha de nacimiento" readonly  
                            class="mt-0 pt-0" :rules="[rules.required]"
                            v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="es"
                          v-model="prisma_solicitud_certificado.fecha_nacimiento"
                          no-title scrollable >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false" > Cancelar </v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(date)" > Seleccionar </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.nit"  
                        class="mt-0 pt-0"
                        :rules="rules.nit"
                        :label="title_nit">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="prisma_solicitud_certificado.cui"  
                        class="mt-0 pt-0"
                        :rules="rules.dpi"
                        label="CUI del DPI o pasaporte">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field 
                          v-model="prisma_solicitud_certificado.telefono"
                          class="mt-0 pt-0"
                          :rules="rules.telefono"
                          :label="title_telefono">
                        </v-text-field>
                      </v-col>
                  </v-row>

                  <template>
                    <v-row v-if="t_certificado == '10002' || t_certificado == '10005' ||  t_certificado == '10004' ">
                      <v-col cols="12" md="6">
                        <v-text-field 
                          v-model="prisma_solicitud_certificado.empresa_labora"  
                          class="mt-0 pt-0"
                          :label="title_empresa_labora">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field 
                          v-model="prisma_solicitud_certificado.area_pertenece"  
                          class="mt-0 pt-0"
                          :label="title_pertenece">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <template v-if="t_certificado == '10003'">
                        <v-col  cols="12" md="6" >
                          <v-text-field 
                            v-model="prisma_solicitud_certificado.profesion"
                            class="mt-0 pt-0"
                            :rules="[rules.required]"
                            label="Profesión">
                          </v-text-field>
                        </v-col>
                      </template>
                      <template  v-if="t_certificado == '10001' || t_certificado == '10002' ||  t_certificado == '10005' ||  t_certificado == '10004'">
                        <v-col cols="12" md="6" >
                          <v-text-field 
                            v-model="prisma_solicitud_certificado.cargo"
                            class="mt-0 pt-0"
                            :label="title_cargo">
                          </v-text-field>
                        </v-col>
                      </template>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          v-model="prisma_solicitud_certificado.pais"
                          @change="changeCountry"
                          :items="pais_tipo"
                          :item-value="pais_tipo.value"
                          :item-text="pais_tipo.text"
                          class="mt-0 pt-0"
                          :rules="[rules.required, rules.select]"
                          label="País">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field 
                          v-model="prisma_solicitud_certificado.municipio"  
                          class="mt-0 pt-0"
                          :rules="[rules.required]"
                          :label="title_ciudad_municipio">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field 
                          v-model="prisma_solicitud_certificado.direccion"  
                          class="mt-0 pt-0"
                          :rules="[rules.required]"
                          :label="title_direccion">
                        </v-text-field>
                      </v-col>    
                    </v-row>
                    <v-row>
                      <!---------------------------------------------------------------->
                      <v-col cols="12">
                       <v-select
                          item-text="nombre"
                          item-value="id"
                          v-model="prisma_solicitud_certificado.tipopago"
                          :items="pago_tipo"
                          class="mt-0 pt-0"
                          label="Tipos de pago"
                          :rules= "[(v) => !!v || 'Requerido']"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </template>
                </v-card-text>
                  <!--
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="primary" 
                      :disabled="validForm == false && habilitar_boton_envio == false" @click="solicitudFirma">
                      Enviar solcitud
                    </v-btn>
                  </v-card-actions>
                  -->
              </v-form>
            
            <v-btn
                color="primary"
                :disabled="validForm == false && habilitar_boton_envio == false" 
                @click="avanzarPaso3()"
            >Continuar</v-btn>
            <v-btn 
              text
              @click="regresarPaso1()"
              >Regresar
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form
                ref="formPass" 
                v-model="validFormPass" 
                lazy-validation>
              <v-row>
                <v-col>
                  <p><b>AVISO IMPORTANTE: 
                  <u>ESTA CONTRASEÑA NO PUEDE SER REESTABLECIDA.</u></b>
                  Por su propia seguridad, <b>UNA VEZ GENERADA LA CONTRASEÑA, 
                  USTED ES RESPONSABLE DE SU RESGUARDO; Y ASI MISMO, DEBE 
                  DE CERCIORARSE DE RECORDAR Y NO OLVIDAR LA MISMA.</b> En caso de 
                  olvido, extravío, compromiso o revelación de la contraseña, 
                  usted deberá de ponerse en contacto con REGISTRO DIGITAL PRISMA,
                  S.A. para dar de baja al certificado. En caso fuere necesaria
                  o requerida nueva gestión de certificado electrónico, se aplicará 
                  el cargo correspondiente,conforme a  la tarifa más reciente al 
                  tipo de certificado en cuestión.</p>
                </v-col>
              </v-row>
              <v-row>
                  <v-dialog
                      ref="dialogogo"
                      v-model="modal"
                      :return-value.sync="fecha_nacimiento"
                      persistent
                      width="290px"></v-dialog>
    
                  <v-col cols="12" md="6">
                  <v-text-field
                    counter
                    v-model="prisma_solicitud_certificado.password_descarga" 
                    :rules="[rules.required, rules.min, rules.contrasena]" 
                    label="Contraseña de firma" 
                    prepend-icon="lock" 
                    id="inputPass1"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                  > </v-text-field>
                  <v-text-field 
                    counter
                    v-model="prisma_solicitud_certificado.password_descarga_confirmacion"                  
                    :rules="[rules.required, passwordConfirmationRule, rules.contrasena]" 
                    label="Confirmar contraseña de firma"
                    prepend-icon="lock" 
                    id="inputPass2"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-alert
                    border="top"
                    colored-border
                    type="warning"
                    elevation="2"
                  >
                    <p>La contraseña debe contener:</p>
                    <ul>
                      <li>Al menos 1 carácter alfabético en minúscula.</li>
                      <li>Al menos 1 carácter alfabético en mayúscula.</li>
                      <li>Al menos 1 carácter numérico.</li>
                      <li>NO caracteres especiales (! @ $ %  & *).</li>
                      <li>La contraseña debe tener ocho caracteres o más.</li>
                    </ul>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
            <v-btn
                color="primary"
                :disabled="validFormPass == false && habilitar_boton_envio == false" 
                @click="avanzarPaso4"
                
              >
                Continuar
            </v-btn>
            <v-btn 
              text
              @click="regresarPaso2()"
              >Regresar
            </v-btn>


              <v-dialog
                ref="dialog2"
                v-model="showErrorSolicitud"
                persistent
                width="450px"
              >

                <v-card elevation="12">
                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: red; font-size: 100px;">dangerous</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Error en la solicitud
                  </v-card-title>

                  <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                    <b> <v-icon small depressed>cancel</v-icon> Información:  </b> {{error_solicitud}}
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="showErrorSolicitud = false"
                    >
                      Aceptar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog
                ref="dialog2"
                v-model="showModal"
                persistent
                width="450px"
              >

                <v-card elevation="12">

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: green; font-size: 100px;">check</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Solicitud iniciada
                  </v-card-title>

                  <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                    <b> <v-icon small depressed>info</v-icon> Información:  </b> Se ha iniciado el proceso de su solicitud con tipo de certificado:<b> {{prisma_solicitud_certificado.titulo}}</b>. Proceda a cargar sus archivos.
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="showModal = false"
                    >
                      Aceptar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              <v-dialog
                ref="dialog2"
                v-model="showModalEdit"
                persistent
                width="450px"
              >

                <v-card elevation="12">

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: red; font-size: 100px;">report_problem</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Documento en Revisión
                  </v-card-title>

                  <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                    <b> <v-icon small depressed>info</v-icon> Información:  </b> 
                    Nuestro equipo le notificará por correo el resultado 
                    y podrá continuar en este mismo enlace.
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="showModalEdit = false"
                    >
                      Aceptar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              
          </v-stepper-content>

          <v-stepper-content step="4">

              <v-form
                ref="formDocs" 
                v-model="validFormDocs" 
                enctype="multipart/form-data"
                lazy-validation>
                <template>
                  <v-row> 
                    <v-col cols="4" v-if="prisma_solicitud_certificado.pais == 'Guatemala' && field_copia_dpi_solicitante">
                      <v-file-input
                        :placeholder="edits_documents['copia_dpi_solicitante'].nombre"
                        v-model="file_dpi"
                        label= "DPI"
                        :rules="edits_documents['copia_dpi_solicitante'].regla"
                        v-on:change="uploadFiles($event,field_copia_dpi_solicitante.documento.id)"
                        :prepend-icon="edits_documents['copia_dpi_solicitante'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>
                    <v-col cols="4" v-if="prisma_solicitud_certificado.pais !== 'Guatemala' && field_copia_pasaporte">
                      <v-file-input
                        :placeholder="edits_documents['copia_pasaporte'].nombre"                        
                        v-model="file_pasaporte"
                        label="Pasaporte"
                        :rules="edits_documents['copia_pasaporte'].regla"
                        v-on:change="uploadFiles($event,field_copia_pasaporte.documento.id)"
                        :prepend-icon="edits_documents['copia_pasaporte'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4"  v-if="field_carta_solicitud">
                      <v-file-input
                        :placeholder="edits_documents['carta_solicitud'].nombre"
                        v-model="file_solicitud"
                        label="Formulario o carta de solicitud"
                        :rules="edits_documents['carta_solicitud'].regla"
                        v-on:change="uploadFiles($event,field_carta_solicitud.documento.id)"
                        :prepend-icon="edits_documents['carta_solicitud'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_carta_representante_legal">
                      <v-file-input
                        :placeholder="edits_documents['carta_representante_legal'].nombre"
                        v-model="file_solicitud_membretada"
                        label="Carta de solicitud membretada y firmada por representante legal"
                        :rules="edits_documents['carta_representante_legal'].regla"
                        v-on:change="uploadFiles($event,field_carta_representante_legal.documento.id)"
                        :prepend-icon="edits_documents['carta_representante_legal'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_constancia_colegiado">
                      <v-file-input
                        :placeholder="edits_documents['constancia_colegiado'].nombre"
                        v-model="file_profesional_titulado"
                        label="Constancia de colegiado activo o carné vigente en su defecto"
                        :rules="edits_documents['constancia_colegiado'].regla"
                        v-on:change="uploadFiles($event,field_constancia_colegiado.documento.id)"
                        :prepend-icon="edits_documents['constancia_colegiado'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_contrato_getor">
                      <v-file-input
                        :placeholder="edits_documents['contrato_getor'].nombre"
                        v-model="file_contrato_getor"
                        label="Contrato de gestor firmado por representante legal"
                        :rules="edits_documents['contrato_getor'].regla"
                        v-on:change="uploadFiles($event,field_contrato_getor.documento.id)"
                        :prepend-icon="edits_documents['contrato_getor'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_anexo_contrato_excel">
                      <v-file-input
                        :placeholder="edits_documents['anexo_contrato_excel'].nombre"
                        v-model="file_anexo_contrato_excel"
                        label="Anexo al contrato gestor en Excel"
                        :rules="edits_documents['anexo_contrato_excel'].regla"
                        v-on:change="uploadFiles($event,field_anexo_contrato_excel.documento.id)"
                        :prepend-icon="edits_documents['anexo_contrato_excel'].icon"
                        accept=".xls, .xlsx"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_anexo_contrato_pdf">
                      <v-file-input
                        :placeholder="edits_documents['anexo_contrato_pdf'].nombre"
                        v-model="file_anexo_gestor"
                        label="Anexo al contrato gestor en PDF"
                        :rules="edits_documents['anexo_contrato_pdf'].regla"
                        v-on:change="uploadFiles($event,field_anexo_contrato_pdf.documento.id)"
                        :prepend-icon="edits_documents['anexo_contrato_pdf'].icon"
                        accept=".pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_copia_patente_comercio">
                      <v-file-input
                        :placeholder="edits_documents['copia_patente_comercio'].nombre"
                        v-model="file_patente_comercio"
                        label="Copia de patente de sociedad y comercio"
                        :rules="edits_documents['copia_patente_comercio'].regla"
                        v-on:change="uploadFiles($event,field_copia_patente_comercio.documento.id)"
                        :prepend-icon="edits_documents['copia_patente_comercio'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>


                    <v-col cols="4" v-if="field_copia_rtu">
                      <v-file-input
                        :placeholder="edits_documents['copia_rtu'].nombre"
                        v-model="file_rtu"
                        label="Copia de RTU de la institución actualizado"
                        :rules="edits_documents['copia_rtu'].regla"
                        v-on:change="uploadFiles($event,field_copia_rtu.documento.id)"
                        :prepend-icon="edits_documents['copia_rtu'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_copia_nombramiento_representante">
                      <v-file-input
                        :placeholder="edits_documents['copia_nombramiento_representante'].nombre"
                        v-model="file_nombramiento"
                        label="Copia nombramiento de representante legal vigente"
                        :rules="edits_documents['copia_nombramiento_representante'].regla"
                        v-on:change="uploadFiles($event,field_copia_nombramiento_representante.documento.id)"
                        :prepend-icon="edits_documents['copia_nombramiento_representante'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if ="field_copia_dpi_representante">
                      <v-file-input
                        :placeholder="edits_documents['copia_dpi_representante'].nombre"
                        v-model="file_dpi_representante"
                        label="Copia DPI del representante legal"
                        :rules="edits_documents['copia_dpi_representante'].regla"
                        v-on:change="uploadFiles($event,field_copia_dpi_representante.documento.id)"
                        :prepend-icon="edits_documents['copia_dpi_representante'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_copia_contrato_laboral">
                      <v-file-input
                        :placeholder="edits_documents['copia_contrato_laboral'].nombre"
                        v-model="file_contrato_publico"
                        label="Copia contrato laboral que vincula al solicitante con la institución pública"
                        :rules="edits_documents['copia_contrato_laboral'].regla"
                        v-on:change="uploadFiles($event,field_copia_contrato_laboral.documento.id)"
                        :prepend-icon="edits_documents['copia_contrato_laboral'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                    <v-col cols="4" v-if="field_constancia_pago">
                      <v-file-input
                        :placeholder="edits_documents['constancia_pago'].nombre"
                        v-model="file_constancia_pago"
                        label="Constancia de pago"
                        :rules="edits_documents['constancia_pago'].regla"
                        v-on:change="uploadFiles($event,field_constancia_pago.documento.id)"
                        :prepend-icon="edits_documents['constancia_pago'].icon"
                        accept="image/png, image/jpeg, .pdf"
                      >
                      </v-file-input>
                    </v-col>

                  </v-row>
                </template>
              </v-form>

              <v-dialog
                ref="dialog3"
                v-model="showNotificationModal"
                persistent
                width="450px"
              >

                <v-card elevation="12">
                  
                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="font-size: 100px;">upgrade</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Archivos cargados
                  </v-card-title>

                  <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                    La solicitud será revisada por nuestro equipo. Se le notificará por correo 
                    cuando pueda continuar con el proceso, en este mismo enlace.
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="showNotificationModal = false; paso = 1;"
                    >
                      Aceptar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              <v-btn  
                color="primary"
                :disabled="!validFormDocs" 
                @click="enableStepMati"
              >
                Continuar
              </v-btn>

            <v-btn text @click="paso = 2" :disabled="disable_back">
              Regresar
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="5">
            <p v-if =showRequestToken>Para habilitar la validación de identidad debe solicitar un token de autenticidad, el token llegará a su cuenta de correo.</p>
            <v-btn
              color="primary"
              @click="requestToken"
              v-if = showRequestToken
            > 
              <v-icon small depressed>markunread</v-icon>
                Solicitar token 
               
            </v-btn>

            <v-dialog
                ref="dialog3"
                v-model="showNotificationToken"
                persistent
                width="450px"
              >

              <v-card elevation="12">
                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: green; font-size: 100px;">offline_pin</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Token enviado
                  </v-card-title>

                <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                  <b> <v-icon small depressed>info</v-icon> Información:  </b> Se ha enviado un correo con un token de verificación, ingrese el token en el campo que se muestra a continuación.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="showNotificationToken = false;"
                  >
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

              <v-form
                ref="formToken" 
                v-show="show_form_token"
                v-model="validFormToken" 
                lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field 
                        v-model="token_validate"  
                        class="mt-0 pt-0"
                        :rules="[rules.required]"
                        label="Ingresar token">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-btn 
                        color="primary" 
                        :disabled="!validFormToken" @click="btnValidarToken">
                        Validar token
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>

              <v-dialog
                ref="dialog3"
                v-model="showValidationToken"
                persistent
                width="450px"
              >

              <v-card elevation="12">
                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: green; font-size: 100px;" v-if="statusValidation">verified_user</v-icon>
                    <v-icon x-large style="color: red; font-size: 100px;" v-if="!statusValidation">highlight_off</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    {{titleValidation}}
                  </v-card-title>

                <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                  <b> <v-icon small depressed>info</v-icon> Información:  </b>{{bodyValidation}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="showValidationToken = false; "
                  >
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
              </v-dialog>

              <mati-button
                id="btn-mati"
                language="es"
                :color="'#0cb5a1'" 
                :size="'large'"
                v-show="show_btn_mati"
                clientid="605baa83e23ad2001b0eb0d0"
                flowId="605baa83e23ad2001b0eb0cf"
                :metadata="getMatiMetaData()">
              </mati-button>

              <v-dialog
                ref="dialog3"
                v-model="showFinalizada"
                persistent
                width="450px"
              >

              <v-card elevation="12">

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    <v-icon x-large style="color: green; font-size: 100px;">done_outline</v-icon>
                  </v-card-title>

                  <v-card-title class="text-h4 lighten-2 justify-center">
                    Solicitud finalizada
                  </v-card-title>

                <v-card-text class="text-h7" style="font-size: 16px; padding-top: 24px;"> 
                  <b> <v-icon small depressed>info</v-icon> Información:  </b> {{boton_envio}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="showFinalizada = false;"
                  >
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
              
              <p v-html="testData"></p>
              <hr>
              <p v-html="testData"></p>
              <v-btn text @click="regresarInicio()">
              Regresar
              </v-btn>

              <!--<v-btn
                color="primary"
                @click="paso = 1"
              >
                finalizar
              </v-btn> -->
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>

      <v-alert
        v-if="$store.state.user.info_firma.solicitud_firma_proceso"
        border="top"
        colored-border
        type="info"
        class="text-center"
        elevation="2"
      >
        Actualmente tiene una solicitud de firma en proceso.
      </v-alert>


      </v-col>
    </v-row>
  </v-container>





</template>

<script>
import axios from "axios";
import moment from 'moment';
export default {
  components: {  },
  data: function() {
    return {
      //url_api : "http://127.0.0.1:3000/prisma/api",
      //url_api : "https://firma-test.infile.com/prisma/api",
      //url_api : "http://172.27.173.50:9099/prisma/api",
      url_api : "https://signer.infile.com/prisma/api",
      show1: false,
      show2: false,
      modal_update : false,
      mostrarFin:true,
      token : "",
      token_validate : "",
      documentos_editables : [],
      statusValidation : true,
      showRequestToken : true,
      titleValidation : null,
      bodyValidation : null,
      showValidationToken: false,
      showNotificationModal: false,
      showErrorSolicitud : false,
      error_solicitud: "Hay un error en su solicitud, verifique la informacion",
      disable_back: false,
      listado_solicitudes : [],
      showModal: false,
      showFinalizada: false,
      showModalEdit: false,
      showNotificationToken: false,
      method_continue : "create",
      field_copia_pasaporte : false,
      field_carta_solicitud : false,
      field_constancia_pago : false,
      field_carta_representante : false,
      field_constancia_colegiado : false,
      field_contrato_getor : false,
      field_anexo_contrato_excel : false,
      field_copia_patente_comercio : false,
      field_copia_contrato_laboral : false,
      field_anexo_contrato_pdf : false,
      field_copia_rtu : false,
      field_copia_nombramineto_representante : false,
      field_copia_dpi_representante : false,
      field_copia_dpi_solicitante : false,
      field_constancia_pago : false,
      solicitud_certificado_id : null,
      paso: 1,
      file_dpi: null,
      file_pasaporte: null,
      file_solicitud_membretada: null,
      file_profesional_titulado: null,
      file_patente_comercio: null,
      file_rtu: null,
      file_solicitud: null,
      file_contrato_getor: null,
      file_anexo_gestor: null, 
      file_anexo_contrato_excel: null,
      file_nombramiento: null,
      file_contrato_publico : null,
      file_dpi_representante: null,
      file_constancia_pago: null,
      prisma_solicitud_certificado : {
          titulo: null,
          primer_nombre: null,
          segundo_nombre: null,
          otros_nombres: null,
          primer_apellido: null,
          segundo_apellido: null,
          casada_apellido: null,
          fecha_nacimiento: new Date().toISOString().substr(0, 10),
          nit: null,
          token: null,
          cui: null,
          telefono: null,
          direccion: null,
          municipio: null,
          pais: "Guatemala",
          razon_social: null,
          nombre_comercial: null,
          nit_empresa: null,
          cargo: null,
          profesion: null,
          empresa_labora: null,
          area_pertenece: null,
          observaciones: null,
          correo: null,
          tipo_certificado: null,
          tipopago: null,
          password_descarga: null,
          password_descarga_confirmacion: null
      },
      t_certificado: null,
      t_certi_object: null,
      documentos_firma: null,
      validForm: false,
      validFormPass: false,
      validFormDocs: false,
      validFormToken: false,
      modal: false,
      menu:false,
      show_form_token: false,
      show_btn_mati: false,
      habilitar_boton_envio: false,
      boton_envio: null,
      title_empresa_labora: 'Donde labora (Empresa)',
      title_nit: 'NIT Solicitante',
      title_telefono: 'Teléfono',
      title_direccion: 'Dirección',
      title_ciudad_municipio: 'Ciudad o Municipio',
      title_pertenece: 'Área al que pertenece (Empresa)',
      title_cargo: 'Cargo',
      estado_solicitud: 'Solicitud',
      pago_tipo: [],
      certificado_tipo: [],
      headers_table : [
        {'text' : 'Solicitud', 'value':'id'},
        {'text' : 'Tipo', 'value' : 'tipo_certificado'},
        {'text' : 'Emisión', 'value' : 'created_at'},
        {'text' : 'Actualización', 'value' : 'updated_at'},
        {'text' : 'Estado', 'value' : 'estado'},
        {'text' : 'Acción', 'value' : 'accion', sortable: false}
      ],
      pais_tipo: [
        {text:"Guatemala", value:"Guatemala"},
        {text:"Otro",value:"extranjero"}
      ],
      absolute: true,
      overlay: false,
      valueOverlay:5,
      rules: {
        required: value => !!value || 'Requerido',
        min: v => v.length >= 8 || 'Min 8 caracteres',
        max: v => v.length <= 50 || 'Máximo 50 caracteres',
        contrasena:  v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(^[A-Za-z0-9]*$)/.test(v) || 'No es una contraseña permitida',
        email: [
          v => !!v || 'Campo requerido',
          v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
        ],
        nit: [
          v => !!v || 'Requerido', 
          v => (/^([0-9]+([0-9]|K|k){1})$/.test(v) || /^((cf|Cf|CF|cF){1})+$/.test(v)) || 'Nit incorrecto, no debe incluir guion (-)'
        ],
        dpi: [
          v => !!v || 'Campo requerido',
          v => (/^([0-9]{13})$/.test(v)) || '13 caracteres para el DPI'
        ],
        telefono: [
          v => !!v || 'Campo requerido',
          v => (/^((\+)|([0-9]))+([0-9])$/.test(v) ) || 'Teléfono invalido'
        ],
        file: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      },
      edits_documents : {
        'copia_pasaporte' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'carta_solicitud' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'carta_representante_legal' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'constancia_colegiado' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'contrato_getor' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'anexo_contrato_excel' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'copia_patente_comercio' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'copia_contrato_laboral' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'anexo_contrato_pdf' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'copia_rtu' : {estado: false, nombre: null ,icon: "mdi-paperclip", regla : false},
        'copia_nombramiento_representante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'copia_dpi_representante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'copia_dpi_solicitante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false},
        'constancia_pago' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : false}
      }
    };
  },
  computed: {
    passwordConfirmationRule() {
        return () => (this.prisma_solicitud_certificado.password_descarga === this.prisma_solicitud_certificado.password_descarga_confirmacion) || 'Contraseñas no coinciden'
    }
  },
  watch: {
    
  },
  created () {

  },
  beforeDestroy () {

  },
  mounted() {
    let btnmati = document.getElementById("btn-mati");

    btnmati.addEventListener('mati:loaded', ({ detail }) => {
        console.log('loaded payload', detail)
    })

    btnmati.addEventListener('mati:userFinishedSdk', ({ detail }) => {
        let headers = {
          "Authorization": this.token
        }
        let getdoc = axios.get(this.url_api+'/solicitudes/'+this.solicitud_certificado_id+'/finalizar_matti',{headers : headers})
        return getdoc.then((response) => {
          this.paso = 1;
          this.obtenerSolicitudes();
          this.habilitar_boton_envio = true;
          this.boton_envio = "Hemos recibido su solicitud. Estaremos revisando la información a la brevedad y nos pondremos en contacto para continuar con el proceso o corregir cualquier dato necesario. Si tiene alguna duda, puede comunicarse al 2506-7070 o a servicioalcliente@prisma.gt"
          this.show_btn_mati = false;
          this.showFinalizada = true;
        }).catch((error) => {
          console.log(error);
        });
      })
0
    btnmati.addEventListener('mati:exitedSdk', ({ detail }) => {
        console.log('exited payload', detail)
        
    })

    this.prisma_solicitud_certificado.correo = this.$store.state.user.email;

    this.loginServicio();

    for (let k in this.edits_documents) {
        this.edits_documents[k].regla = [this.rules.required];
    }
    
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  methods: {
    regresarInicio(){
        this.show_form_token = false;
        this.showNotificationToken = false;
        this.showRequestToken = true;
        this.token_validate = "";
        this.show_btn_mati = false;
        this.paso = 1;
    },
    loginServicio(){
        let headers = {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        }

        let body = {
          'llave' : 'ba48099e7f67a6b196844b8c8ae7f105',
          'usuario' : 'PrismaGT',
          'password' : 'MJEA0esHrbYlQoBdT++KEQ==',
          'correo' : this.$store.state.user.email
        }
        
        let getdoc = axios.post(this.url_api+'/login', body,{headers : headers})
        return getdoc.then((response) => {
          this.token = response.data.respuesta.token;
          this.certificado_tipos();
          this.pago_tipos();
          this.obtenerSolicitudes();
        }).catch((error) => {
          console.log(error);
        });
    },
    initializeDocuments() {
      this.edits_documents = {
        'copia_pasaporte' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'carta_solicitud' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'carta_representante_legal' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'constancia_colegiado' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'contrato_getor' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'anexo_contrato_excel' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_patente_comercio' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_contrato_laboral' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'anexo_contrato_pdf' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_rtu' : {estado: false, nombre: null ,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_nombramiento_representante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_dpi_representante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'copia_dpi_solicitante' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]},
        'constancia_pago' : {estado: false, nombre: null,icon: "mdi-paperclip", regla : [this.rules.required]}
      }

      this.file_dpi = null;
      this.file_pasaporte = null;
      this.file_solicitud_membretada = null;
      this.file_patente_comercio = null;
      this.file_rtu = null;
      this.file_solicitud = null;
      this.file_gestor_firmado = null;
      this.file_anexo_gestor = null;
      this.file_anexo_contrato_excel = null;
      this.file_nombramiento = null;
      this.file_contrato_publico = null;
      this.file_dpi_representante = null;
    },
    initializeSolicitud(){
        this.prisma_solicitud_certificado = {
          titulo: null,
          primer_nombre: null,
          segundo_nombre: null,
          otros_nombres: null,
          primer_apellido: null,
          segundo_apellido: null,
          casada_apellido: null,
          fecha_nacimiento: new Date().toISOString().substr(0, 10),
          nit: null,
          token: null,
          cui: null,
          telefono: null,
          direccion: null,
          municipio: null,
          pais: "Guatemala",
          razon_social: null,
          nombre_comercial: null,
          nit_empresa: null,
          cargo: null,
          profesion: null,
          empresa_labora: null,
          area_pertenece: null,
          observaciones: "Prisma",
          correo: this.$store.state.user.email,
          tipo_certificado: null,
          tipopago: null,
          password_descarga: null,
          password_descarga_confirmacion: null
      }
    },
    moment: function (date) {
      return moment(date);
    },
    date: function (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    stopCharge(){
      this.modal_update = false;
    },
    actualizarTabla(){
      this.modal_update = true;

      this.obtenerSolicitudes();

      setTimeout(this.stopCharge, 1000);

      
    },
    regresarPaso1(){
      this.paso = 1; 
      this.obtenerSolicitudes();
      this.$refs.formFirma.reset()
    },
    regresarPaso2(){
      console.log("Regresando a paso 2");
      this.paso = 2; 
    },
    avanzarPaso3(){
      this.$refs.formFirma.validate();
      this.paso = 3; 
    },
    avanzarPaso4() {
      this.$refs.formFirma.validate();
      this.$refs.formPass.validate();
      let headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Authorization": this.token
      }

      let getdoc = axios.get(this.url_api+'/certificado_tipos/'+this.t_certificado, {headers : headers})
      return getdoc.then((response) => {
        this.documentos_firma = response.data.resultado[0].certificado_documentos;
        console.log(this.documentos_firma);
        this.mostrarCampos();
        console.log("MOSTRANDO CAMPOS")

        if (this.$refs.formFirma.validate() && this.$refs.formPass.validate() ) {
          console.log("VALIDANDO")
          this.notificacionToPrisma();
          console.log("METODO ",this.method_continue)
          if(this.method_continue === 'create'){
            this.saveData();
          }else{
            this.updateData();
          }
        }
        else
        {
           this.showErrorSolicitud = true
        };
      }).catch((error) => {
        this.showErrorSolicitud = true
        console.log(error)
      });
    
    },
     obtenerSolicitudes(){
      let headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Authorization": this.token
      }
      let getdoc = axios.get(this.url_api+'/solicitudes/?correo='+this.prisma_solicitud_certificado.correo, {headers : headers})
      return getdoc.then((response) => {
        
        this.listado_solicitudes = response.data.resultado
        console.log("LISTADO DE SOLICITUDES PENDIENTES",this.listado_solicitudes);
      }).catch((error) => {
        console.log(error);
      });

    },
    certificado_tipos(){
      let headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Authorization": this.token
      }
      let getdoc = axios.get(this.url_api+'/certificado_tipos/', {headers : headers})
      return getdoc.then((response) => {
        this.certificado_tipo = response.data.resultado;
      }).catch((error) => {
        console.log(error);
      });
    },
    pago_tipos(){
      let headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Authorization": this.token
      }
      let getdoc = axios.get(this.url_api+'/pago_tipos/', {headers : headers})
      return getdoc.then((response) => {
        this.pago_tipo = response.data.resultado;
      }).catch((error) => {
        console.log(error);
      });
    },
    cargar_archivo(){
      console.log("carga de archivo...");

    
    },
    changeCountry(e){

    },
    containsElement(elemento,propiedad){
        for (let k in this.documentos_firma) {
            if(this.documentos_firma[k].documento[propiedad] === elemento){
              return this.documentos_firma[k];
            }
              
        }
        return false;
    },
    updateData(){
      
      this.initializeDocuments();

      console.log("ACTUALIZAR INFORMACION");
      this.method_continue = 'update';


      let headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json",
        "Authorization": this.token
      }

      let body_solicitud = {};

      Object.keys(this.prisma_solicitud_certificado).map((key) => {
        if(this.prisma_solicitud_certificado[key]) {
          body_solicitud[key] = this.prisma_solicitud_certificado[key]
        }
      });

      let params = {
        "prisma_solicitud_certificado": body_solicitud
      }

      let getdoc = axios.put(this.url_api+'/solicitudes/'+this.solicitud_certificado_id,params,{headers : headers})
      return getdoc.then((response) => {
        this.solicitud_certificado_id = response.data.resultado.id;
        this.method_continue = 'update';
        this.paso = 4;

        this.documentos_editables = response.data.resultado.prisma_solicitud_documentos;

        
        this.foundEdits();
        console.log("DOCUMENTOS EDITABLES ",this.edits_documents);


      }).catch((error) => {
        console.log(error);
      });

    },
    foundEdits(){
      let nombre ="";
      for (let k in this.documentos_editables) {
          if(this.documentos_firma.filter((e) => 
          {
            if(e.documento.id === this.documentos_editables[k].documento_id){
              nombre = e.documento.nombre;
              return true;
            }else{
              return false;
            }
          })){
            this.edits_documents[nombre].estado = true;
            this.edits_documents[nombre].nombre = this.documentos_editables[k].archivo_file_name;
            this.edits_documents[nombre].icon = "mode_edit";
            this.edits_documents[nombre].regla = false;
          }
      }

      console.log("RESULTADO DEL EDIT: ",this.edits_documents);
    },
    saveData(){

        let headers = {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': '*',
          "Authorization": this.token
        }

        let body_solicitud = {};

        Object.keys(this.prisma_solicitud_certificado).map((key) => {
          if(this.prisma_solicitud_certificado[key]) {
            body_solicitud[key] = this.prisma_solicitud_certificado[key]
          }
        });

        let params = {
          "prisma_solicitud_certificado": body_solicitud
        } 

        console.log("BODY ",body_solicitud)

        console.log("PARAMS ",params);

        let getdoc = axios.post(this.url_api+'/solicitudes/',params,{headers : headers})
        return getdoc.then((response) => {
          this.solicitud_certificado_id = response.data.resultado.id;
          this.method_continue = 'update'
          this.paso = 4;
          this.showModal = true;
          this.initializeDocuments();
         }).catch((error) => {
          
          console.log(error.response.data)
          this.showErrorSolicitud = true;
          console.log(error.response.data.resultado);
          this.error_solicitud = error.response.data.resultado
            
        });
    },
    
    mostrarCampos(){
      this.field_copia_pasaporte = this.containsElement("copia_pasaporte","nombre");
      this.field_carta_solicitud = this.containsElement("carta_solicitud","nombre");
      this.field_constancia_pago = this.containsElement("constancia_pago","nombre");
      this.field_carta_representante_legal = this.containsElement("carta_representante_legal","nombre");
      this.field_constancia_colegiado = this.containsElement("constancia_colegiado","nombre");
      this.field_contrato_getor = this.containsElement("contrato_getor","nombre");
      this.field_anexo_contrato_excel = this.containsElement("anexo_contrato_excel","nombre");
      this.field_copia_patente_comercio= this.containsElement("copia_patente_comercio","nombre");
      this.field_copia_contrato_laboral = this.containsElement("copia_contrato_laboral","nombre");
      this.field_anexo_contrato_pdf = this.containsElement("anexo_contrato_pdf","nombre");
      this.field_copia_rtu = this.containsElement("copia_rtu","nombre");
      this.field_copia_nombramiento_representante = this.containsElement("copia_nombramiento_representante","nombre");
      this.field_copia_dpi_representante = this.containsElement("copia_dpi_representante","nombre");
      this.field_copia_dpi_solicitante = this.containsElement("copia_dpi_solicitante","nombre");
      this.field_constancia_pago = this.containsElement("constancia_pago","nombre");
    },
    
    iniciarVerificacion(solicitud){
      
      this.paso = 5;
      this.showRequestToken = true;
      this.token_validate = "";
      console.log("solicitud",solicitud);
      this.solicitud_certificado_id = solicitud.id;
      this.disable_back_verificacion = true;
    },
    enableStepMati() {
      this.$refs.formDocs.validate();

      if (this.$refs.formDocs.validate()) {
        this.notificacionToPrisma();
        this.disable_back = true;

        let headers = {
          "Authorization": this.token
        }


        let getuser = axios.get(this.url_api+'/solicitudes/'+this.solicitud_certificado_id+'/finalizar/',{headers : headers})
        return getuser.then((callback) => {
          console.log("Envio de correo");
          this.showNotificationModal = true;
          this.paso = 1;
          this.obtenerSolicitudes();
          return true;
        }).catch((error) => {
          console.log("Hay errores en la solicitud");
          console.log(error);
          this.error_solicitud = error.response.data.respuesta;
          this.showErrorSolicitud = true;
          return false;
        });

      }
    },
    notificacionToPrisma() {
      console.log("notificando carga de documentos...")
    },
    uploadFiles(e,id) {
      let _this1 = this;
      _this1.asyncDocumentosMultipart(e,id).then(function(callback)
      {
        if(callback){
          console.log("Archivo cargado.");
        }
      });
    },
    async asyncDocumentosMultipart(file,id) {
      let x = await this.subirArchivoMultipart(file,id);
      return x;
    },
    subirArchivoMultipart(item,id) {

      if(item !== null && item !== undefined){
        const formData = new FormData();
        formData.append('archivo', item, item.name);
        formData.append('nombre_archivo', item.name);
        formData.append('documento_id',id)
        formData.append('solicitud_certificado_id',this.solicitud_certificado_id)
        formData.append('type',item.type);

        let headers = {
          "Content-Type": "multipart/form-data",
          "Authorization": this.token
        }

        let getuser = axios.post(this.url_api+'/solicitudes/cargar_archivo', formData,  {headers : headers})
        return getuser.then((callback) => {
          console.log("post --> subirArchivo",callback);
          return true;
        }).catch((error) => {
          console.log("subirArchivo error");
          console.log(error);
          return false;
        });
      } 


    },
    requestToken() {
      let headers = {
        "Authorization": this.token
      }

      let getuser = axios.get(this.url_api+'/solicitudes/'+this.solicitud_certificado_id+'/solicitar_token',{headers : headers})
      return getuser.then((callback) => {
        console.log("post --> subirArchivo",callback);
        this.show_form_token = true;
        this.showNotificationToken = true;
        this.showRequestToken = false;
        return true;
      }).catch((error) => {
        console.log("subirArchivo error");
        console.log(error);
        this.showRequestToken = true;
        return false;
      });
    },
    btnValidarToken() {

      let headers = {
        "Authorization": this.token
      }
      
      let body = {
        'token' : this.token_validate,
        'id' : this.solicitud_certificado_id
      }

      let getuser = axios.post(this.url_api+'/solicitudes/validar_token',body,{headers : headers})
      return getuser.then((callback) => {
        console.log("post --> subirArchivo",callback);
        this.statusValidation = true;
        this.showValidationToken  = true;
        this.titleValidation = "Token verificado";
        this.bodyValidation = "Su token ha sido verificado con exito, continue con el proceso de validación.";
        this.show_btn_mati = true;
        this.showRequestToken = false;
        this.show_form_token = false;
        return true;
      }).catch((error) => {
        console.log("subirArchivo error");
        console.log(error);
        this.statusValidation = false;
        this.showValidationToken  = true;
        this.titleValidation = "Token invalido";
        this.bodyValidation = "El token ingresado no es valido, intente nuevamente.";
        this.show_btn_mati = false;
        this.showRequestToken = true;
        this.show_form_token = true;
        return false;
      });
    },
    solicitudFirma() {
      if (this.$refs.formFirma.validate())
      {
        console.log("entro a solicitud");
        /*let vData = {
          "estado": "ACTIVO",
          "razon_social": this.razon_social,
          "nombre_comercial": this.nombre_comercial,
          "primer_nombre": this.primer_nombre,
          "segundo_nombre": this.segundo_nombre,
          "otros_nombres": this.otros_nombres,
          "primer_apellido": this.primer_apellido,
          "segundo_apellido": this.segundo_apellido,
          "casada_apellido": this.casada_apellido,
          "correo": this.$store.state.user.email,
          "fecha_nacimiento": this.fecha_nacimiento,
          "nit": this.nit,
          "dpi": this.pasaporte_pdi,
          "pasaporte": this.pasaporte_pdi,
          "empresa": "Infile",
          "area_pertenece": this.area_pertenece,
          "profesion": this.profesion,
          "telefono": this.telefono,
          "t_certificado": this.t_certificado,
          "pais": this.pais,
          "municipio": this.municipio,
          "direccion": this.direccion,
          "observaciones": this.observaciones,
          "rostro": this.$store.state.user.foto_rostro,
          "dpi_anverso": this.$store.state.user.foto_dpi_anverso,
          "dpi_reverso": this.$store.state.user.foto_dpi_reverso
        }*/

        alert("En proceso...");
        this.$refs.formFirma.reset();

        /*
        let postSocitud = axios.post('SolicitudFirma/crear', vData, { 'headers': this.$store.state.user.headers })
        return postSocitud.then((callback) => 
        {
          console.log(callback);
          if(callback.status == 201){
            //this.dialog = false;
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Solicitud correcta.' });
          } 
        }).catch((error) => {
          console.log(error);
        });
        */
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.nombre.toLowerCase()
      const textTwo = item.descripcion.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    nuevaSolicitud(){
      this.initializeSolicitud();
      this.method_continue = "create";
      this.paso = 2;
    },
    editItem(item){

      this.estado_solicitud = item.estado;
      this.solicitud_certificado_id = item.id;
      this.method_continue = "update";

       if(item.estado === 'Revision'){
        this.showModalEdit = true;
        return;
      }

      this.t_certi_object = this.certificado_tipo.find(elemento=> elemento.tipo === item.tipo_certificado);
      this.prisma_solicitud_certificado.titulo = this.t_certi_object.nombre;
      this.prisma_solicitud_certificado.tipo_certificado = this.t_certi_object.tipo;
      this.t_certificado = this.t_certi_object.id;


      Object.keys(item).map((key) => {
          if(item[key]) {
            this.prisma_solicitud_certificado[key] = item[key]
          }
      });

      this.paso = 2;
      

    },
    changeFields(e,id) {

      this.prisma_solicitud_certificado.titulo = this.t_certi_object.nombre;
      this.prisma_solicitud_certificado.tipo_certificado = this.t_certi_object.tipo;
      this.t_certificado = this.t_certi_object.id;

      let flag = "(Empresa)";
      this.title_nit = "NIT Solicitante";
      if(e == 'funcionario_publico')  {
        flag = "(Entidad)";
      }
      if(this.t_certificado == '10001') {        
        this.title_nit = "NIT (Empresa)";
      }

      if(this.t_certificado == '10001' || this.t_certificado == '10002' || this.t_certificado == '10005') {        
        this.title_cargo = "Cargo (como indica nombramiento)"
      } else {title_cargo = "Cargo"}
      

      this.title_empresa_labora = "Donde labora "+flag;
      this.title_telefono = "Teléfono "+flag;
      this.title_direccion= "Dirección "+flag;
      this.title_ciudad_municipio= "Ciudad o Municipio "+ flag;
      this.title_pertenece ="Área al que pertenece "+ flag;


    },
    getMatiMetaData(){   
      //console.log("getMatiMetaData");
      let meta_data = {"email": this.$store.state.user.email, "color": '#0cb5a1' };

      return JSON.stringify(meta_data);
    }
  },
};
</script>